import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
    width: "100vw",
  },
  iframe: {
    width: "100%",
    height: "100%",
  },
  gameContainer: {
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  gameBox: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    zIndex: 1,
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: `${theme.colors.background7} 0.6`,
    backdropFilter: "blur(6px)",
    zIndex: theme.zIndex.dialog + 1 - 1,
  },
  endScreen: {
    zIndex: `${theme.zIndex.dialog + 1} !important`,
  },
}));
